import Vue from 'vue'
import Router from 'vue-router'
import identification from './components/identification.vue'
import notfound from './components/notfound.vue'
import login from './components/login.vue'
import forgotpass from './components/forgotpass.vue'
import logined from './components/logined.vue'
import serviceClosed from './components/service-closed.vue'
import onetimeInput from './components/onetimeinput.vue'
import onetimeAuth from './components/onetimeauth.vue'
import authenticated from './components/authenticated.vue'


Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    // {
    //   path: '/',
    //   redirect: '/login'
    // },
    {
      path: '/identification',
      name: 'identification',
      component: identification
    },
    {
      path: '/login',
      name: 'login',
      component: login,
    },
    {
      path: '/forgotpass',
      name: 'forgotpass',
      component: forgotpass
    },
    {
      path: '/logined',
      name: 'logined',
      component: logined,
      props: true
    },
    {
      path: '/service-closed',
      name: 'service-closed',
      component: serviceClosed
    },
    {
      path: '/onetime-input',
      name: 'onetime-input',
      component: onetimeInput
    },
    {
      path: '/onetime-auth',
      name: 'onetime-auth',
      component: onetimeAuth
    },
    {
      path: '/authenticated',
      name: 'authenticated',
      component: authenticated
    },

    {
      path: '*',
      name: 'notfound',
      component: notfound
    }
  ]
})
